import { AuthGuard, USAGE_MODE } from '@agent-ds/shared/guard';
import { PageInfo, DashboardType } from '@agent-ds/shared/interfaces';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import {
  AuthService,
} from '@agent-ds/shared/services';

/**
 * レイアウト
 */
@Component({
  selector: 'ag-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnDestroy {
  // Constants
  /** 業績管理表を表示するDashboardType一覧 */
  readonly CA_GYOSEKI_MANAGEMENT_HEADER_DISPLAY_DASHBOARD_TYPES = [DashboardType.CA, DashboardType.CA_Manager];
  /** RA業績管理表を表示するDashboardType一覧 */
  readonly RA_GYOSEKI_MANAGEMENT_HEADER_DISPLAY_DASHBOARD_TYPES = [DashboardType.RAPA, DashboardType.RA_Manager];

  // View Flags
  useLayout = true;
  displayGyosekiManagementHeader = false;
  displayRaGyosekiManagementHeader = false;
  loginSubscription = null;

  @Input()
  set pageInfo(pageInfo: PageInfo) {
    this.useLayout = (pageInfo ? pageInfo.layout : true) && AuthGuard.CURRENT_USAGE === USAGE_MODE.APP;
    this.updateDisplayGyosekiManagementHeaderFromAuthInfo();
  }

  constructor(
    private readonly authService: AuthService
  ) {}

  ngOnInit() {
    this.updateDisplayGyosekiManagementHeaderFromAuthInfo();
  }

  ngOnDestroy() {
    if(this.loginSubscription) {
      this.loginSubscription.unsubscribe();
      this.loginSubscription = null;
    }
  }

  updateDisplayGyosekiManagementHeaderFromAuthInfo() {
    this.loginSubscription = this.authService.isLogined().subscribe((logined) => {
      if (!logined || !this.authService.loginUser) {
        this.displayGyosekiManagementHeader = false;
        return;
      }
      this.displayGyosekiManagementHeader = this.CA_GYOSEKI_MANAGEMENT_HEADER_DISPLAY_DASHBOARD_TYPES.includes(
        this.authService.loginUser.dashboardType
      );
      this.displayRaGyosekiManagementHeader = this.RA_GYOSEKI_MANAGEMENT_HEADER_DISPLAY_DASHBOARD_TYPES.includes(
        this.authService.loginUser.dashboardType
      );
    });
  }
}
